<template>
  <page-edicion>
    <page-header :title="plan.nombre" subtitle="Plan" back-to="/planes" />
    <formulario :plan="plan" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import api from "@/services/planes.js";

export default {
  components: { Formulario },
  data() {
    return {
      plan: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      api.cargar(id).then((response) => {
        this.plan = response.plan;
      });
    },
    actualizar() {
      api.actualizar(this.plan).then(() => {
        this.$messages.success("Se ha actualizado el plan");
        this.$router.push({ path: "/planes" });
      });
    },
  },
};
</script>
